import { useMemo } from 'react';

import {
    useAppSelector,
    ticketTotalPagesSelector,
    sentMessageSelector,
    editingMessageSelector,
    ticketInfoSelector,
    ticketLoadingSelector,
    useUserProfileQuery,
} from '../../../app/store';
import useTicketFetchData from './ticket-fetch-data-hook';
import useTicketMessageHandlers from './ticket-message-handlers-hook';
import useTicketActions from './ticket-actions-hook';
import useTicketErrorHandlers from './ticket-error-handlers-hook';
import useTicketHelpers from './ticket-helpers-hook';
import useTicketItem from '../components/ticket-item/use-ticket-item';

const useTicketPage = () => {
    const ticketInfo = useAppSelector(ticketInfoSelector);
    const ticketTotalPages = useAppSelector(ticketTotalPagesSelector);
    const editingMessage = useAppSelector(editingMessageSelector);
    const sentMessage = useAppSelector(sentMessageSelector);
    const { data: profileInfo } = useUserProfileQuery();
    const loadingTicketData = useAppSelector(ticketLoadingSelector);
    const { onRefetchInfo } = useTicketItem();

    const ticketFetchDataHook = useTicketFetchData();

    const {
        onSendMessage,
        onSendMessageToServer,
        loadingSendMessage,
        errorSendMessage,
    } = useTicketMessageHandlers();

    const {
        onEditMessage,
        onCancelEditMessage,
        onCancelMessage,
        onPaginateMessages,
        onSatisfaction,
    } = useTicketActions();

    const { isMessageError } = useTicketErrorHandlers(errorSendMessage);

    const { onSendErrorFile, onIsMessageError, fileSizeLimit } =
        useTicketHelpers();

    return useMemo(
        () => ({
            ticketInfo,
            userInfo: profileInfo,
            loadingMessages: loadingTicketData,
            ticketTotalPages,
            editingMessage,
            sentMessage,
            isSendingMessage: loadingSendMessage,
            isMessageError,
            fileSizeLimit,
            setIsMessageError: onIsMessageError,
            onSend: onSendMessage,
            onResend: onSendMessageToServer,
            onCancel: onCancelMessage,
            onPaginate: onPaginateMessages,
            onEdit: onEditMessage,
            onCancelEdit: onCancelEditMessage,
            onSatisfaction: onSatisfaction,
            onErrorFile: onSendErrorFile,
            onRefetchInfo,
        }),
        [
            ticketInfo,
            loadingTicketData,
            ticketTotalPages,
            editingMessage,
            sentMessage,
            loadingSendMessage,
            isMessageError,
            onSendMessage,
            onSendMessageToServer,
            onCancelMessage,
            onPaginateMessages,
            onEditMessage,
            onCancelEditMessage,
            onSatisfaction,
            onSendErrorFile,
            onRefetchInfo,
        ],
    );
};

export default useTicketPage;
